export default "__VITE_ASSET__B1Iss0po__"